<template lang="pug">
  v-container.px-10(fluid)
    v-row
      v-col
        .section__title {{ $t("Product.generalInformation") }}
    v-row
      v-col(cols="2")
        app-entity-autocomplete(
          :entity="$findEntity('BusinessScope')",
          @input="$store.commit(setInstancePathAction, { path: path + '.businessScope', value: $event })",
          :init="instance.businessScope",
          :label="$t('Product.businessScope')"
        )
      v-col(cols="2")
        v-text-field(
          :value="instance.externalId",
          :label="$t('Product.externalId')",
          :error-messages="errors['product.externalId']",
          disabled
        )
      v-col(cols="2")
        v-text-field(
          :value="instance.referenceId",
          @input="$store.commit(setInstancePathAction, { path: path + '.referenceId', value: $event })",
          :label="$t('Product.externalReference')",
          :error-messages="errors['product.referenceId']",
        )
      v-col(cols="4")
        v-text-field(
          :value="instance.name",
          @input="$store.commit(setInstancePathAction, { path: path + '.name', value: $event })",
          :label="$t('Product.name')",
          :error-messages="errors['product.name']",
        )
      v-col(cols="4")
        v-text-field(
          :value="instance.description",
          @input="$store.commit(setInstancePathAction, { path: path + '.description', value: $event })",
          :label="$t('Product.productDescription')",
        )
    v-row
      v-col
        .section__title {{ $t("Product.weightDimensions") }}
    v-row
      v-col(cols="2")
        v-text-field(
          :value="instance.width",
          @input="$store.commit(setInstancePathAction, { path: path + '.width', value: $event })",
          :label="$t('Product.width')",
          type="number",
          min="0"
          :error-messages="errors['product.Width']",
        )
      v-col(cols="2")
        v-text-field(
          :value="instance.length",
          @input="$store.commit(setInstancePathAction, { path: path + '.length', value: $event })",
          :label="$t('Product.length')",
          type="number",
          min="0"
          :error-messages="errors['product.Lenght']",
        )
      v-col(cols="2")
        v-text-field(
          :value="instance.height",
          @input="$store.commit(setInstancePathAction, { path: path + '.height', value: $event })",
          :label="$t('Product.height')",
          type="number",
          min="0"
          :error-messages="errors['product.Height']",
        )
      v-col(cols="2")
        v-select(
          :value="instance.dimensionsUnit",
          @input="$store.commit(setInstancePathAction, { path: path + '.dimensionsUnit', value: $event })",
          :label="$t('Product.unit')",
          :items="['in', 'ft', 'cm', 'm']",
          :error-messages="errors['product.DimensionsUnit']",
        )
      v-col(cols="2")
        v-text-field(
          :value="instance.weight",
          @input="$store.commit(setInstancePathAction, { path: path + '.weight', value: $event })",
          :label="$t('Product.weight')",
          type="number",
          min="0"
          :error-messages="errors['product.Weight']",
        )
      v-col(cols="2")
        v-select(
          :value="instance.weightUnit",
          @input="$store.commit(setInstancePathAction, { path: path + '.weightUnit', value: $event })",
          :label="$t('Product.weightUnit')",
          :items="['lb', 'kg']",
          :error-messages="errors['product.WeightUnit']",
        )
    v-row
      v-col
        .section__title {{ $t("Product.details") }}
    v-row
      v-col(cols="2")
        v-text-field(
          :value="instance.htsCode",
          @input="$store.commit(setInstancePathAction, { path: path + '.htsCode', value: $event })",
          :label="$t('Product.htsCode')",
          :error-messages="errors['product.HTSCode']",
        )
      v-col(cols="2")
        v-text-field(
          :value="instance.unCode",
          @input="$store.commit(setInstancePathAction, { path: path + '.unCode', value: $event })",
          :label="$t('Product.unCode')",
          :error-messages="errors['product.UNCode']",
        )
      v-col(cols="2")
        v-switch(
          :input-value="instance.isHazardous",
          :label="$t('Product.hazardous')",
          @change="$store.commit(setInstancePathAction, { path: path + '.isHazardous', value: $event })",
          :error-messages="errors['product.IsHazardous']",
        )
      v-col()
        v-text-field(
          :value="instance.remarks1",
          filled,
          @input="$store.commit(setInstancePathAction, { path: path + '.remarks1', value: $event })",
          :label="$t('Product.remarks')",
          :error-messages="errors['product.Remarks1']",
          style=""
        )
</template>
<script>
import EntityMixin from '@/mixins'

export default {
  mixins: [EntityMixin],
  name: 'entity-add',
  props: ['path', 'entity'],
  data: () => ({
    p: {},
    businessScopes: [],
  }),

  computed: {
    errors(){
     return this.$store.state.errors;
    },
    uid() {
      return this.$route.params.item;
    },
  },
  async created() {
    if(!this.uid) {
      this.$store.commit(this.setInstancePathAction, { path: this.path + '.businessScope', value: this.$store.state.user.user.businessScope })
    }
  },
}
</script>
<style>
.v-text-field--filled input {
  margin-top: 16px !important;
}

.v-text-field--filled > .v-input__control > .v-input__slot {
  min-height: inherit !important;
}
</style>
